import { gql } from '@apollo/client';
import { ACTION_BUDGET_ITEM_BASIC } from '../../queries/budget/actionBudgetItems';

// Agregar partida a una acción
export const ADD_BUDGET_ITEM_TO_ACTION = gql`
  mutation AddBudgetItemToAction(
    $actionId: ID!
    $budgetItemId: ID!
    $quantity: Float!
  ) {
    addBudgetItemToAction(
      actionId: $actionId
      budgetItemId: $budgetItemId
      quantity: $quantity
    ) {
      ...ActionBudgetItemBasic
    }
  }
  ${ACTION_BUDGET_ITEM_BASIC}
`;

// Actualizar cantidad de una partida en acción
export const UPDATE_ACTION_BUDGET_ITEM_QUANTITY = gql`
  mutation UpdateActionBudgetItemQuantity($id: ID!, $quantity: Float!) {
    updateActionBudgetItemQuantity(id: $id, quantity: $quantity) {
      ...ActionBudgetItemBasic
    }
  }
  ${ACTION_BUDGET_ITEM_BASIC}
`;

// Eliminar partida de una acción
export const REMOVE_BUDGET_ITEM_FROM_ACTION = gql`
  mutation RemoveBudgetItemFromAction($id: ID!) {
    removeBudgetItemFromAction(id: $id) {
      ...ActionBudgetItemBasic
    }
  }
  ${ACTION_BUDGET_ITEM_BASIC}
`;

// Actualizar múltiples partidas de una acción
export const UPDATE_ACTION_BUDGET_ITEMS = gql`
  mutation UpdateActionBudgetItems(
    $actionId: ID!
    $items: [ActionBudgetItemInput!]!
  ) {
    updateActionBudgetItems(actionId: $actionId, items: $items) {
      ...ActionBudgetItemBasic
    }
  }
  ${ACTION_BUDGET_ITEM_BASIC}
`;

// ✅ NUEVAS MUTATIONS BATCH PARA ESTANDARIZACIÓN

// Actualizar múltiples cantidades de partidas (batch)
export const UPDATE_MANY_ACTION_BUDGET_ITEM_QUANTITIES = gql`
  mutation UpdateActionBudgetItems(
    $actionId: ID!
    $items: [ActionBudgetItemInput!]!
  ) {
    updateActionBudgetItems(actionId: $actionId, items: $items) {
      ...ActionBudgetItemBasic
    }
  }
  ${ACTION_BUDGET_ITEM_BASIC}
`;

// Eliminar múltiples partidas de acción (batch)
export const REMOVE_MANY_BUDGET_ITEMS_FROM_ACTION = gql`
  mutation RemoveManyBudgetItemsFromAction($ids: [ID!]!) {
    removeManyBudgetItemsFromAction(ids: $ids) {
      ...ActionBudgetItemBasic
    }
  }
  ${ACTION_BUDGET_ITEM_BASIC}
`;

// Añadir múltiples partidas a acción (batch)
export const ADD_MANY_BUDGET_ITEMS_TO_ACTION = gql`
  mutation AddManyBudgetItemsToAction(
    $actionId: ID!
    $items: [AddBudgetItemToActionInput!]!
  ) {
    addManyBudgetItemsToAction(actionId: $actionId, items: $items) {
      ...ActionBudgetItemBasic
    }
  }
  ${ACTION_BUDGET_ITEM_BASIC}
`;
